import { useMemo } from 'react';
import { MappedEvaluationItem } from '../types';

export const useSortedData = (data: MappedEvaluationItem[], sortType: string) => {
  return useMemo(() => {
    if (!data.length || !sortType) return data;

    const sortedData = [...data];

    if (sortType === 'expiresAt') {
      return sortedData.sort((a, b) => {
        if (!a.expiresAt || a.expiresAt === '-') return 1;
        if (!b.expiresAt || b.expiresAt === '-') return -1;

        try {
          const [da, ma, ya] = a.expiresAt.split('/').map(Number);
          const [db, mb, yb] = b.expiresAt.split('/').map(Number);
          const dateA = new Date(ya, ma - 1, da);
          const dateB = new Date(yb, mb - 1, db);
          return dateA.getTime() - dateB.getTime();
        } catch {
          return 0;
        }
      });
    }

    return sortedData.sort((a, b) => {
      const aValue = a[sortType as keyof MappedEvaluationItem];
      const bValue = b[sortType as keyof MappedEvaluationItem];
      
      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;
      
      if (aValue > bValue) return 1;
      if (aValue < bValue) return -1;
      return 0;
    });
  }, [data, sortType]);
};
